import type React from "react";
import type { Channel } from "@/types/channel/channel";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useDeleteChannel } from "@/hooks/channel/useDeleteChannel";
import { useToast } from "@/hooks/ui/use-toast";

interface DeleteChannelDialogProps {
	channel: Channel | null;
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const DeleteChannelDialog: React.FC<DeleteChannelDialogProps> = ({
	channel,
	open,
	onOpenChange,
}) => {
	const { deleteChannel, loading } = useDeleteChannel();
	const { toast } = useToast();

	if (!channel) return null;

	const handleDelete = async () => {
		try {
			await deleteChannel(channel.id);
			toast({
				title: "チャンネルを削除しました",
				variant: "default",
			});
			onOpenChange(false);
		} catch (error) {
			toast({
				title: "チャンネルの削除に失敗しました",
				variant: "destructive",
			});
		}
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>チャンネルを削除</DialogTitle>
					<DialogDescription>
						本当に「{channel.name}」を削除しますか？ この操作は取り消せません。
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						キャンセル
					</Button>
					<Button
						variant="destructive"
						onClick={handleDelete}
						disabled={loading}
					>
						{loading ? "削除中..." : "削除する"}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
